import React from "react";

export default function Design() {
  return (
    <li className="skills__container__cards__card skills__container__cards__item">
      <div className="skills__container__cards__card__frame">
        <h2 className="skills__container__cards__card__frame__title">
          <i className="ri-pantone-fill"></i>
        </h2>
      </div>
      <div className="skills__container__cards__card__overlay"></div>
      <div className="skills__container__cards__card__content">
        <h2>Design</h2>
        <ul>
          <li>Adobe XD</li>
          <li>Figma</li>
          <li>Photoshop</li>
          <li>UX/UI Design</li>
          <li>Wireframing</li>
          <li>Prototyping</li>
        </ul>
      </div>
    </li>
  );
}
